mutation RecordProduct(
    $origin: EnumProductOrigin!
    $product: ProductInput!
    $selector: ProductSelectorInput!
) {
    recordProduct(
        origin: $origin
        product: $product
        selector: $selector
    ) {
        errors {
            message
        }
        product {
            id
            revisionID
        }
    }
}
